module.exports = __webpack_public_path__ + "img/down-gd1.de869bc8.png";